import React, { ReactNode } from 'react';
import { TableContainer } from '../styles';


interface IProps {
    children: ReactNode;
    tableHeader?: React.ReactNode;
    className?: string;
    placeholder?: boolean;
}
const TableLayout: React.FC<IProps> = ({ children, tableHeader, className, placeholder }) => {
    return (
        <TableContainer className={className || ''} placeholder={placeholder}>
            {tableHeader && tableHeader}
            {children}
        </TableContainer>
    );
};
export default TableLayout;
